import { getCountryNames, getCountryObjs } from '@luxuryescapes/lib-countries';

import { BEDBANK_PROPERTY_STATUSES_ENUM } from './bedbank';

export const statusOptions = BEDBANK_PROPERTY_STATUSES_ENUM.map((status) => ({
  label: status,
  value: status,
}));

export const booleanOptions = [
  {
    label: 'Yes',
    value: 'true',
  },
  {
    label: 'No',
    value: 'false',
  },
];

export const countriesOptions = getCountryNames().map((country) => ({
  label: country,
  value: country,
}));

export const countriesIsoOptions = getCountryObjs().map((country) => ({
  label: country.countryName,
  value: country.iso2,
}));

export const ratingOperations = [
  {
    value: '',
    label: 'Op',
  },
  {
    value: 'gt',
    label: '>',
  },
  {
    value: 'lt',
    label: '<',
  },
  {
    value: 'eq',
    label: '=',
  },
  {
    value: 'lte',
    label: '<=',
  },
  {
    value: 'gte',
    label: '>=',
  },
];

export const ratingValues = [
  {
    value: '',
    label: 'Value',
  },
  {
    value: '3',
    label: '3',
  },
  {
    value: '3.5',
    label: '3.5',
  },
  {
    value: '4',
    label: '4',
  },
  {
    value: '4.5',
    label: '4.5',
  },
  {
    value: '5',
    label: '5',
  },
];

export const guestRatingCountOptions = [
  {
    value: '',
    label: 'Count',
  },
  {
    value: '0-99',
    label: '0-99',
  },
  {
    value: '100-499',
    label: '100-499',
  },
  {
    value: '500-999',
    label: '500-999',
  },
  {
    value: '1000-plus',
    label: '1000+',
  },
];

export const paymentMethodOptions = [
  {
    value: '',
    label: 'Payment Method',
  },
  {
    value: 'leCollect',
    label: 'LeCollect',
  },
  {
    value: 'propertyCollect',
    label: 'PropertyCollect',
  },
  {
    value: 'both',
    label: 'Both',
  },
];
